import cx from 'classix';
import { Icon } from '../atoms';

type ErrorBoxProps = {
  showAlertTriangle?: boolean;
  variant?: 'default' | 'compact';
} & React.PropsWithChildren;

export const ErrorBox = (props: ErrorBoxProps) => {
  const { showAlertTriangle, variant = 'default' } = props;
  return (
    <div
      className={cx(
        'flex text-sm items-center',
        variant === 'compact' ?
          'border border-error-100 bg-error-25 text-error-600 rounded-lg px-3.5 py-2.5 gap-2'
        : 'border border-gray-200 bg-error-25 shadows-xs min-h-[52px] p-4 gap-4',
      )}
    >
      {showAlertTriangle && (
        <div className='flex items-center justify-center'>
          <Icon type='alert-triangle' size={variant === 'compact' ? '16' : '24'} />
        </div>
      )}
      {props.children}
    </div>
  );
};
